import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetRondAndFieldList = createAsyncThunk(
  "DropDowns/GetRondAndFieldList",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/EvaluatorInfo/GetRondAndFieldList",

        param
      );

      const data = response.data.result;
      console.log(data, "dataaaa");

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const FieldRondReducer = createSlice({
  name: "RoundFieldList",
  initialState: {
    RoundFieldList: [],
    loadingRoundFieldList: false,
    errorRoundFieldList: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetRondAndFieldList.pending, (state, action) => {
        state.loadingRoundFieldList = true;
        state.RoundFieldList = action.payload;
        state.errorRoundFieldList = null;
      })
      .addCase(GetRondAndFieldList.fulfilled, (state, action) => {
        state.loadingRoundFieldList = false;
        state.RoundFieldList = action.payload;
      })
      .addCase(GetRondAndFieldList.rejected, (state, action) => {
        state.loadingRoundFieldList = false;
        state.RoundFieldList = action.payload;
      });
  },
});

export default FieldRondReducer.reducer;
